import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface ErrorDisplayProps {
  message?: string;
  defaultTranslationKey: string;
  Illustration: ReactNode;
}

export function ErrorDisplay({
  message,
  defaultTranslationKey,
  Illustration,
}: ErrorDisplayProps) {
  const { t } = useTranslation();
  const displayMessage = message ? t(message) : t(defaultTranslationKey);

  return (
    <div
      id="error-page"
      className="w-full h-full flex flex-col justify-center items-center"
    >
      <div className="w-full max-w-[600px] px-2">{Illustration}</div>
      <p className="text-xl text-center">{displayMessage}</p>
    </div>
  );
}
